import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import React, { useState, useEffect } from "react";
import { companyProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { toast } from "react-toastify";
import { renderImage } from "../../../utils/helper.jsx";
import { useAuth } from "../../../contexts/AuthContext";

function Feedback() {
  const { email } = useAuth();
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(false);
  const [companyFile, setcompanyFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [dataToSend, setDataToSend] = useState({
    company_name: "",
    company_logo: "",
    currency: "USD",
    email: email,
    subject: "",
    Description: "",
    overview_level: "",
    contact_person: "",
    timezone: "+8",
    contact_number: "",
    contact_email: "",
  });
  async function getCompany() {
    try {
      const res = await companyProfile.list();
      const data = await parserAPI(res);
      setCompany(data);
    } catch (e) {
      console.error(e);
    }
  }
  useEffect(() => {
    getCompany();
  }, []);
  useEffect(() => {
    if (company) {
      getRecord();
    }
  }, [company]);
  async function getRecord() {
    setPreview(renderImage(`/machine/attachment/${company.company_logo}`));
    setDataToSend((prevData) => ({
      ...prevData,
      company_name: company.company_name,
      company_logo: company.company_logo,
      currency: company.currency,
      currency_symbol: company.currency_symbol,
      timezone: company.timezone,
      company_address: company.company_address,
      overview_level: company.overview_level,
      contact_person: company.contact_person,
      contact_number: company.contact_number,
      contact_email: company.contact_email,
    }));
  }

  useEffect(() => {
    if (!companyFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(companyFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [companyFile]);
  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setcompanyFile(undefined);
      return;
    }
    setcompanyFile(e.target.files[0]);
  };

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleEdit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      const res = await companyProfile.update(company.id, hasil, companyFile);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          getCompany();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      const res = await companyProfile.create(hasil, companyFile);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          getCompany();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Feedback</li>
          </ol>
          <h1 className="page-header mb-0">Feedback</h1>
        </div>
      </div>

      <div className="row gx-4 justify-content-center">
        <div className="col-lg-8">
          <Card className="mb-4">
            <CardHeader>Feedback</CardHeader>
            <CardBody>
              <div
                style={{
                  padding: "20px",
                  paddingTop: "50px",
                  position: "relative",
                }}
              >
                <div className={"row justify-content-center"}>
                  <div className={"col-md-12 col-sm-12"}>
                    <div className={"form-group mb-3"}>
                      <label>What can we help you with?</label>
                      <select
                        className="form-control"
                        value={dataToSend["overview_level"]}
                        onChange={handleOnchange}
                        name="overview_level"
                      >
                        <option value="Request">Request</option>
                        <option value="Feedback">Feedback</option>
                        <option value="Bugs Report">Bugs Report</option>
                      </select>
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Email</label>
                      <input
                        disabled
                        readOnly
                        type="text"
                        className="form-control"
                        value={dataToSend["email"]}
                        label="Email"
                        onChange={handleOnchange}
                        name="email"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Subject</label>
                      <input
                        type="text"
                        className="form-control"
                        value={dataToSend["subject"]}
                        label="Subject"
                        onChange={handleOnchange}
                        name="subject"
                      />
                    </div>
                    <div className={"form-group  mb-3"}>
                      <label>Description</label>
                      <textarea
                        rows={3}
                        className="form-control"
                        value={dataToSend["description"]}
                        onChange={handleOnchange}
                        name="description"
                      />
                      <small>
                        Type your question or a description of the problem
                        you're trying to solve here. Please, try be a specific
                        as possible
                      </small>
                    </div>
                    <div className="mb-3">
                      <label>Attachment</label>
                      <small>
                        Allowed file types: jpg, jpeg, png, gif, pdf, doc, docs,
                        xls, xlsx, odt, ppt, pptx and less than 100 MB
                      </small>
                      <Card>
                        <CardBody style={{ padding: "7px" }}>
                          <label
                            htmlFor="filesupload"
                            style={{ width: "100%" }}
                          >
                            <>
                              <div
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  minHeight: "150px",
                                  alignItems: "center",
                                  transform: "translate(-50%, -50%)",
                                }}
                              >
                                <i className="fa fa-file-import"></i>
                                <div>Attach a File</div>
                              </div>
                            </>
                          </label>
                          <input
                            id="filesupload"
                            onChange={onSelectFile}
                            style={{ visibility: "hidden" }}
                            type="file"
                            accept="image/png, image/jpeg, image/jpg, image/gif, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.text, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                          />
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
                <div
                  style={{ textAlign: "center", marginTop: "5px" }}
                  mt={2}
                  mb={1}
                >
                  <button
                    className={"btn btn-theme"}
                    disabled={!dataToSend["company_name"]}
                    color="info"
                    onClick={handleEdit}
                  >
                    SAVE
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default Feedback;
